// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

// Component
import { PublicPortalWelcomeComponent } from './public-portal-welcome.component';

// Directives
import { DirectivesModule } from '../../../directives/directives.module';

// Edit Controls
import { EditControlsModule } from '../../edit-controls/edit-controls.module';

@NgModule({
    declarations: [
        PublicPortalWelcomeComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatMenuModule,
        MatRipple,
        DirectivesModule,
        EditControlsModule
    ],
    exports: [
        PublicPortalWelcomeComponent
    ]
})
export class PublicPortalWelcomeModule { }
